// extracted by mini-css-extract-plugin
export default {"container":"XXGrje","image":"qySt_A","content":"eN2s5w"};